"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const __1 = require("../..");
const InfoPanel = ({ idConfirmButton, onClick, datesListHighlight, selectedDate, disabledButton = false, }) => {
    const renderDates = (date) => (react_1.default.createElement("li", { key: date.description },
        react_1.default.createElement("span", null, `${date.date.date()} - ${date.description}`)));
    const leftDates = () => {
        const dates = datesListHighlight === null || datesListHighlight === void 0 ? void 0 : datesListHighlight.filter((holydays) => (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.month()) === holydays.date.month() &&
            (selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.year()) === holydays.date.year());
        return dates === null || dates === void 0 ? void 0 : dates.map(renderDates);
    };
    const rightDates = react_1.useCallback(() => {
        const newData = selectedDate === null || selectedDate === void 0 ? void 0 : selectedDate.clone().add(1, 'month');
        const dates = datesListHighlight === null || datesListHighlight === void 0 ? void 0 : datesListHighlight.filter((holydays) => {
            return ((newData === null || newData === void 0 ? void 0 : newData.month()) === holydays.date.month() &&
                (newData === null || newData === void 0 ? void 0 : newData.year()) === holydays.date.year());
        });
        return dates === null || dates === void 0 ? void 0 : dates.map(renderDates);
    }, [selectedDate, datesListHighlight]);
    return (react_1.default.createElement("div", { className: "calendar-information-panel" },
        react_1.default.createElement("div", { className: "date-information-panel" },
            react_1.default.createElement("ul", { className: "date-left-side" }, leftDates()),
            react_1.default.createElement("ul", { className: "date-right-side" }, rightDates())),
        react_1.default.createElement("div", { className: "action-panel" },
            react_1.default.createElement(__1.SmlsButton, { id: idConfirmButton, text: "Confirmar", className: "button-confirm", onClick: onClick, disabled: disabledButton }))));
};
exports.default = InfoPanel;
//# sourceMappingURL=InfoPanel.js.map